import React from "react";
import { Link, useLocation } from "react-router-dom";

// Catch-all for unknown URLs so a mistyped/old link never shows a blank page.
export default function NotFoundPage() {
  const { pathname } = useLocation();
  const inDash = pathname.startsWith("/dashboard");
  return (
    <div className={`${inDash ? "py-24" : "min-h-[70vh]"} flex flex-col items-center justify-center text-center px-6`} data-testid="not-found-page">
      <p className="text-[11px] uppercase tracking-[0.3em] text-[var(--gold)] mb-3">404</p>
      <h1 className="font-serif text-4xl mb-3">This page doesn't exist</h1>
      <p className="text-sm text-[var(--muted)] mb-8 max-w-sm">The link may be old or mistyped.</p>
      <Link to={inDash ? "/dashboard" : "/"} className="btn-gold" data-testid="not-found-home">{inDash ? "Back to dashboard" : "Go home"}</Link>
    </div>
  );
}
